import { Order } from '@/coreDomainsModule/entities/order';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { UpdateOrderInfoRequestAdapter } from '../adapters/updateOrderInfoRequestAdapter';

/**
 *　発注の更新を行うユースケース
 */
export class UpdateOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注情報を更新する
   * @param order - 発注情報
   */
  public async Execute(order: Order): Promise<INetworkResult<undefined, IError>> {
    try {
      // 保存する前に分納が存在する場合は、分納の中で最も遅い納期を発注の納期に設定する
      if (order.partialDeliveries.length > 0) {
        const latestDeliveryDate = order.partialDeliveries.reduce((prev, current) => {
          return prev.deliveryDate > current.deliveryDate ? prev : current;
        });
        order.estimatedTimeOfArrival = latestDeliveryDate.deliveryDate;
      }
      const request = UpdateOrderInfoRequestAdapter.adapt(order);
      const response = await this.repository.update(request);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
